"use client";
import { FC } from "react";
import { AppButton } from "@/components/common/Buttons";
import Phone from "@/components/common/Phone";
import Image from "next/image";
import PhoneTooltip from "@/components/common/PtoneTooltip";
import { PHONE_TOOLTIPS } from "@/ui/data";

const TITLES = [
	"a partner, at hand, all the time",
	"like playing a real bridge game, not robot bridge",
	"extremely fun bridge, accessible anywhere",
];

type Props = {
	strapiData: any;
};

const App: FC<Props> = ({ strapiData }) => {
	const powerSharkItems = strapiData?.powerSharkIsData?.data;
	const powerSharkList = Array.isArray(powerSharkItems)
		? powerSharkItems
		: powerSharkItems
			? [powerSharkItems]
			: [];
	const titlesFromStrapi = powerSharkList.map((el: any) => el.attributes);
	const titles = titlesFromStrapi.length
		? titlesFromStrapi
		: TITLES.map((text) => ({ text }));

	const tooltipsItems = strapiData?.tooltipsData?.data;
	const tooltipsList = Array.isArray(tooltipsItems)
		? tooltipsItems
		: tooltipsItems
			? [tooltipsItems]
			: [];
	const tooltips = tooltipsList.map((el: any) => el.attributes);

	const combineTooltips = PHONE_TOOLTIPS.map((el: any, index: number) => ({
		...el,
		number: tooltips[index]?.number ?? el.number,
		text: tooltips[index]?.text ?? el.text,
	}));
	return (
		<div className=' bg-appScreenGradient w-full h-[100%] pt-[120px] max-desktop:pt-[65px] max-tablet:pt-[20px]  px-[90px] max-desktop:px-[30px] max-tablet:px-[16px] '>
			{/* Top */}
			<div className='flex max-tablet:flex-col max-tablet:items-center max-tablet:gap-y-[58px] justify-between'>
				<div className='flex flex-col max-tablet:px-[22px]'>
					<p className='text-[58px] max-desktop:text-[40px] mb-[15px] font-bold max-tablet:text-center max-tablet:mt-[10px]'>
						PowerShark is
					</p>
					{titles.map((el: any, index: number) => (
						<div
							key={index}
							className={`flex items-center gap-[12px] max-desktop:gap-[6px] mb-[13px] max-desktop:w-[325px] ${
								index === 0 ? "max-tablet:w-[286px]" : ""
							}`}>
							<Image
								width={32}
								height={32}
								alt='CheckMark icon'
								src='/icons/checkmark.svg'
								className='w-[32px] h-[32px] max-desktop:w-[18px] max-desktop:h-[18px] max-tablet:mb-[10px]'
							/>
							<p className='text-[27px] max-desktop:text-[20px] leading-6 max-desktop:leading-[20px] tracking-[1.5px]'>
								{el.text}
							</p>
						</div>
					))}
					<div className='flex gap-[10px] mt-[75px] max-tablet:mt-[23px] max-desktop:mt-[34px] max-tablet:justify-center'>
						<AppButton os='ios' />
						<AppButton os='android' />
					</div>
				</div>
				<Phone />
			</div>
			{/* Bot */}
			<div className='pr-[23px] pl-[-2px] max-desktop:pl-[4px] max-tablet:pl-0 max-tablet:pt-0 max-desktop:pr-[2px] flex flex-col items-start max-desktop:items-center'>
				<p className='text-[58px] max-desktop:text-[40px] max-desktop:tracking-wider  max-tablet:text-center max-tablet:mt-[30px] font-[700] max-desktop:mt-[84px] tracking-[1.5px] leading-[77px] max-desktop:leading-[53px] max-tablet:leading-[40px] max-tablet:tracking-[1px]'>
					PowerShark in numbers:
				</p>
				<div className='flex mt-[27px] max-tablet:mt-[30px] max-tablet:flex-col max-tablet:items-center'>
					<div className='flex flex-col gap-y-[37px] max-desktop:gap-y-[22px] max-tablet:gap-y-0'>
						{combineTooltips.map((el: any, index: number) => (
							<PhoneTooltip
								number={el.number}
								text={el.text}
								white={el.white}
								key={index}
							/>
						))}
					</div>
					<Image
						width={402}
						height={556}
						alt='Phone'
						src='/images/pokerPhone.png'
						className=' aspect-[402/556] min-w max-desktop:w-[219px] max-desktop:h-[311px] max-tablet:hidden '
					/>
				</div>
				<div className='hidden max-tablet:block h-[12px] border-[1px] w-[1px] mx-auto'></div>
				<Image
					width={402}
					height={556}
					alt='Phone'
					src='/images/pokerPhoneM.png'
					className='hidden aspect-[196/401] min-w max-desktop:w-[196px] max-tablet:block '
				/>
			</div>
		</div>
	);
};

export default App;
